import {useEffect} from 'react'
import {useSearchParams} from '@github-ui/react-router'
import {useNavigate} from '@github-ui/use-navigate'
import {PULLS_INBOX_PATH, PULLS_SEARCH_PATH} from '../constants/routes'
import {getDefaultView} from '@github-ui/shared-dashboard-surface/hooks/use-save-default-view'
import {usePullsDashboardPayload} from '../contexts/PullsDashboardSurfaceStateContext'
import {pullsDashboardSurfaceContentRoute} from './pulls-dashboard-surface-content-route'

/**
 * Index-route gate for /pulls.
 * - /pulls?q=xxx  → redirects to /pulls/search?q=xxx
 * - /pulls        → redirects to the user's default view (cookie), defaulting to /pulls/inbox
 */
export function PullsDashboardIndexGate() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const hasQuery = searchParams.has('q')
  const payload = usePullsDashboardPayload()
  // Prefer the client-side cookie (most recent user choice); fall back to the
  // server-provided default so first-time SPA loads still honor the saved preference.
  const defaultView = getDefaultView('pull-requests') ?? payload.defaultViewId

  useEffect(() => {
    // Treat /pulls?q=xxx as a search entry point and forward to the dedicated search route.
    if (hasQuery) {
      navigate({pathname: PULLS_SEARCH_PATH, search: searchParams.toString()}, {replace: true})
      return
    }

    // No default (or explicit "inbox") → navigate to the inbox route.
    // Otherwise redirect to the user's default view.
    if (!defaultView || defaultView === 'inbox') {
      navigate({pathname: PULLS_INBOX_PATH}, {replace: true})
    } else {
      navigate({pathname: pullsDashboardSurfaceContentRoute.generatePath({mode: defaultView})}, {replace: true})
    }
  }, [defaultView, hasQuery, navigate, searchParams])

  return null
}
